





















import { Component, Ref, Vue } from "vue-property-decorator";
import BaseDialogComponent from "@/components/common/BaseDialog.vue";
import { ClientPartner, ClientPartnerLinkClient } from "@/data/models/ClientPartner";
import { setClientPartnerLink } from "@/data/repository/ClientAdministrationRepository";
import { SnackbarModule } from "@/store/modules/SnackbarModule";
import { partnerErrorKey } from "@/utils/ClientPartners";

@Component({
  components: { "base-dialog": BaseDialogComponent },
})
export default class ClientPartnerLinkDialog extends Vue {
  @Ref("baseDialog")
  baseDialog!: BaseDialogComponent;

  busy = false;
  clientId = "";
  partnerId = "";
  partnerName = "";
  candidates: ClientPartnerLinkClient[] = [];
  memberClientId: string | null = null;

  private resolve: ((result: ClientPartner | null) => void) | null = null;

  /**
   * @param clientId - the system's owner, whose page this is.
   * @param partner - the system, with its candidates.
   */
  show(clientId: string, partner: ClientPartner): Promise<ClientPartner | null> {
    this.clientId = clientId;
    this.partnerId = partner.id;
    this.partnerName = partner.name;
    this.candidates = partner.links?.candidates ?? [];
    this.memberClientId = null;
    this.baseDialog.show({
      title: this.$t("admin.clients.partners.links.linkTitle", [partner.name]).toString(),
      positiveButtonText: this.$t("admin.clients.partners.links.link").toString(),
      negativeButtonText: this.$t("common.close").toString(),
      maxWidth: 560,
      persistent: true,
      closeOnSave: false,
    });
    return new Promise((resolve) => (this.resolve = resolve));
  }

  async onLink() {
    if (!this.memberClientId) {
      return;
    }
    this.busy = true;
    try {
      const saved = await setClientPartnerLink(this.clientId, this.partnerId, this.memberClientId, true);
      SnackbarModule.showSuccess({ key: "admin.clients.partners.links.linked" });
      this.baseDialog.isShowing = false;
      this.finish(saved);
    } catch (error) {
      SnackbarModule.showError({ key: partnerErrorKey(error) });
    } finally {
      this.busy = false;
    }
  }

  /** SCHLIEßEN: BaseDialog has closed itself; one choice is nothing worth confirming. */
  onClose() {
    this.finish(null);
  }

  private finish(result: ClientPartner | null) {
    this.resolve?.(result);
    this.resolve = null;
  }
}
